export enum EAppItemType {
	SMALL = 'small',
	MEDIUM = 'medium',
	HORIZONTAL = 'horizontal',
	WIDE = 'wide',
	LARGE = 'large',
}
